import { QueryClient } from '@tanstack/react-query'

/**
 * React Query Client Configuration
 *
 * Global defaults for all queries:
 * - Moderate retry strategy (2 attempts)
 * - No automatic refetching on window focus
 * - Cache for 5 minutes by default (override per-query as needed)
 *
 * Note: Currently no persistence configured. Future enhancement will add
 * persistence plugin with security filtering to exclude sensitive queries.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes default (override per-query)
      gcTime: 1000 * 60 * 10, // 10 minutes default garbage collection
    },
  },
})

export default queryClient
